export default {
  SETTING_UPDATED: 'Setting updated',
  PASSWORD_UPDATED: `Password updated`,
  USERNAME_UPDATED: `Username updated`,
  PRONOUNS_UPDATED: `Pronouns updated`,
  ATTRIBUTES_UPDATED: `Attributes updated`,
  PIN_UPDATED: `PIN updated`,
  ATTRIBUTE: {
    CREATED: `Attribute created`,
    UPDATED: `Attribute modified`
  },
  BREAK: {
    CREATED: `Break created`,
    UPDATED: `Break modified`
  },
  BREAK_RULE: {
    CREATED: `Break rule created`,
    UPDATED: `Break rule modified`
  },
  DEPARTMENT: {
    CREATED: `Department created`,
    UPDATED: `Department modified`
  },
  HIRING_DATA: {
    CREATED: `Hiring data created`,
    UPDATED: `Hiring data modified`
  },
  WAGE_PREMIUM: {
    CREATED: `Wage premium created`,
    UPDATED: `Wage premium modified`
  },
  PERMISSION: {
    CREATED: `Permission created`,
    UPDATED: `Permission modified`
  },
  POSITION: {
    CREATED: `Position created`,
    UPDATED: `Position modified`
  },
  PUNCH_CARD: {
    CREATED: `Punch card created`,
    UPDATED: `Punch card modified`
  },
  REQUEST_OPTION: {
    CREATED: `Request option created`,
    UPDATED: `Request option modified`
  },
  SCHEDULE_TEMPLATE: {
    CREATED: `Schedule template created`,
    UPDATED: `Schedule template modified`
  },
  SCHEDULE_TYPE: {
    CREATED: `Schedule type created`,
    UPDATED: `Schedule type modified`
  },
  TAG: {
    CREATED: `Tag created`,
    UPDATED: `Tag modified`
  },
  TEAM: {
    CREATED: `Team created`,
    UPDATED: `Team modified`
  },
  ATTENDANCE: {
    CREATED: `Attendance request created`,
    UPDATED: `Attendance request modified`
  },
  AVAILABILITY: {
    CREATED: `Availability created`,
    UPDATED: `Availability modified`
  },
  TIME_OFF: {
    CREATED: `Time off created`,
    UPDATED: `Time off modified`
  },
  BULLETIN: {
    CREATED: `Bulletin created`,
    UPDATED: `Bulletin modified`
  },
  NOTIFICATION_TEMPLATE: {
    CREATED: `Notification template created`,
    UPDATED: `Notification template modified`
  },
  PROJECT: {
    CREATED: `Project created`,
    UPDATED: `Project modified`
  },
  PUNCH_RULE: {
    CREATED: `Punch rule created`,
    UPDATED: `Punch rule modified`
  },
  USER: {
    CREATED: `User created`,
    UPDATED: `User modified`
  },
  USER_TEMPLATE: {
    CREATED: `User template created`,
    UPDATED: `User template modified`
  },
  HOLIDAY: {
    CREATED: `Holiday created`,
    UPDATED: `Holiday modified`,
    DELETED: `Holiday deleted`
  },
  AVAILABILITY_IMPORT: {
    CREATED: `Availabilities imported successfully`
  },
  SCHEDULE_IMPORT: {
    CREATED: `Shifts imported successfully`
  },
  SCHEDULETEMPLATE_IMPORT: {
    CREATED: `Schedule template imported successfully`
  },
  PUNCH_IMPORT: {
    CREATED: `Punch cards imported successfully`
  },
  PROJECTS_IMPORT: {
    CREATED: `Projects imported successfully`
  },
  TIMEOFF_IMPORT: {
    CREATED: `Time offs imported successfully`
  },
  REPORT_INTERCOM: `Click here to report this error`,
  JOB_RUN: {
    UPDATED: `Job ran successfully`
  },
  ALL_SHIFTS_FILLED: `All selected shifts were autofilled`,
  SOME_SHIFTS_FILLED: `At least one selected shift was autofilled`,
  NO_SHIFTS_FILLED: `No selected shifts were autofilled`
}
